<template>
  <v-container>

    <div class="casesearch-query-log">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap">
            みんなの相談検索：検索ワードランキング
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
                @on-month-changed="saveSelectedDate"
              />
          </div>
          <v-btn
            variant="flat"
            prepend-icon="custom:download"
            height="40"
            border="md"
            @click="downloadCSV"
            class="text-glance-primary ml-2 font-weight-bold border-current"
          >
            CSVダウンロード
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-table class="table-row-border font-size-10-rem">
        <thead class="height-45">
          <tr>
            <th
              class="text-center w-15 font-weight-bold"
            >
              順位
            </th>
            <th
              class="text-center w-15 font-weight-bold"
            >
              利用サイト
            </th>
            <th
              class="text-center font-weight-bold"
            >
              検索ワード
            </th>
            <th class="text-center w-15 font-weight-bold">
              検索数
            </th>
          </tr>
        </thead>
        <tbody class="height-40">
          <tr
            v-for="(casesearchQueryLog,index) in displayedCasesearchQueryLogs"
            :key="index"
            :class="[ casesearchQueryLog.departmentType === '小児科' ? 'bg-syounika' : 'bg-obstetrics' ]"
          >
            <td class="text-center">
              {{ casesearchQueryLog.rank }}
            </td>
            <td class="text-center">
              {{ casesearchQueryLog.departmentType }}
            </td>
            <td class="text-center">
              {{ casesearchQueryLog.keyword }}
            </td>
            <td class="text-center">
              {{ casesearchQueryLog.count }}
            </td>
          </tr>
        </tbody>
      </v-table>

      <div class="mt-2 mb-5 d-flex justify-end">
        <v-btn
          v-if="showToggleExpandBtn"
          variant="flat"
          id="toggleExpandBtn"
          :color="color.mainColor()"
          class="ml-2 px-4 font-weight-bold text-white"
          @click="toggleExpand"
        >
          <template v-if="isExpanded">
            検索ワードランキングを閉じる
            <v-icon
              icon="mdi-chevron-up"
              class="ml-1"/>
          </template>
          <template v-else>
            検索ワードランキングをもっと見る
            <v-icon
              icon="mdi-chevron-down"
              class="ml-1"/>
          </template>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import { textFormatter } from "../service/text_formatter";
import { useStore } from "../stores/index";
import monthPicker from "./shared/MonthPicker.vue";
import { themeColor } from "../service/theme_color"

export default defineComponent({
  name: "CasesearchQueryLogList",
  components: {
    monthPicker
  },
  setup() {
    // settings
    const color = themeColor()

    // 初期表示する行数
    const initialDisplayCount = 20

    const store = useStore()
    const newLineCodeToBr = textFormatter().newLineCodeToBr

    // 事例検索クエリログのリストを取得
    const casesearchQueryLogs = computed(() => store.getters.logs)
    // 選択された日付を取得
    const selectedDate = computed(() => new Date(store.getters.selectedCasesearchQueryLogDate))
    // もっと見る展開状態
    const isExpanded = ref(false)

    // 表示する事例検索クエリログのリストを取得
    const displayedCasesearchQueryLogs = computed(() => {
      if (isExpanded.value) {
        return casesearchQueryLogs.value
      } else {
        return casesearchQueryLogs.value.slice(0, initialDisplayCount)
      }
    })

    // 展開ボタンを表示するかどうかの判定
    // initialDisplayCountよりも件数が多い場合に表示する
    const showToggleExpandBtn = computed(() => {
      return casesearchQueryLogs.value.length > initialDisplayCount
    })

    // 展開状態を切り替える
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value
    }

    // 選択された日付を保存する
    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedCasesearchQueryLogDate", selectedValue)
    }

    // CSVをダウンロードする
    const downloadCSV = async () => {
      await store.dispatch("downloadCasesearchQueryLogs")
    }

    // コンポーネントがマウントされたときに選択された日付を保存する
    onMounted(() => {
      store.dispatch("commitSelectedCasesearchQueryLogDate", selectedDate.value)
    })

    return {
      selectedDate,
      casesearchQueryLogs,
      displayedCasesearchQueryLogs,
      saveSelectedDate,
      newLineCodeToBr,
      downloadCSV,
      initialDisplayCount,
      isExpanded,
      toggleExpand,
      showToggleExpandBtn,
      color
    }
  }
})
</script>
